import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eee77ed8: FaireBrandEntity = {
  token: "b_eee77ed8",
  type: "brand",
  name: "People I've Loved",
  avatarUrl:
    "https://cdn.faire.com/fastly/b889f35247ebcd0b1d4da227eb4398893b42c0abcc1f9ca66a2238b363209349.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b5ad582ccbeaa828a6e88489329bff31918d4191fa41feaa25b9253d2be668a4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b889f35247ebcd0b1d4da227eb4398893b42c0abcc1f9ca66a2238b363209349.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b5ad582ccbeaa828a6e88489329bff31918d4191fa41feaa25b9253d2be668a4.png",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 225,
  isInsider: true,
  description:
    "We are a few human beings longing for connection / a small printmaking workshop based out of Oakland, California. We specialize in hand-printed & assembled objects. People I've Loved's works (or pressing issues) intend to facilitate the communication between real, tactile people. Not that we want to deny people their digital selves, we just think there can be room for both.\n\nPeople I've Loved started in 2011 when Carissa Potter left Colpa Press to focus on creating a stationary line that would bridge the gap between people by helping them have authentic and sometimes difficult conversations. Carissa thinks about each card as a form of performance art that choreographs interactions between humans in various types of relationships. Giving in to nostalgic thoughts on the past, buried longings and hopes for the future, People I've Loved's product line embraces the whole range of emotions. We are “in search of the miraculous” yet tragic definition of what it means to exist, in this time and space. And feel that we should make time to share it.\n\nOver the years, People I've Loved has had an awesome team. We believe that more brains are better than one, and do all concept development as a team. We talk about our issues & interests as a group and see how we can address them authentically to help people get through their days. \n\nTake a deep long breath, things will turn out alright. ",
  meta: {
    source: "api",
    importedAt: "2026-07-17T22:00:36.874Z",
    importedBy: "entity-db-cli",
  },
};
